export * from './errorCodes';

export const defaultSiteLanguage = import.meta.env.VITE_SITE_LOCALE === 'us' ? 'en-us' : 'en-gb';
export const isUs = defaultSiteLanguage === 'en-us';
export const phoneNumberPrefix = isUs ? '+1' : '+44';

const patientSupportPhoneNumberUk = '0808 304 9869';
const patientSupportPhoneNumberUs = '+1 888 454 5580';
export const patientSupportPhoneNumber = isUs
	? patientSupportPhoneNumberUs
	: patientSupportPhoneNumberUk;
export const isRouterDevToolsEnabled =
	import.meta.env.VITE_ENABLE_TANSTACK_ROUTER_DEV_TOOLS === 'true';
export const OTHER_HCI_VALUE = '__other__';
